import { DAY_END_MIN, DAY_START_MIN, DEFAULT_EST_MIN } from "./constants";

export interface CapacityInput {
  estMin?: number | null;
  status?: string | null;
}

export interface Capacity {
  usedMin: number;
  capMin: number;
  pct: number; // 0..100
  over: boolean; // > 90% of capacity
}

/**
 * Day capacity — ported from the prototype's plan-view capacity bar. Sums the
 * estimates of not-done tasks against the length of the working day.
 */
export function capacity(
  tasks: ReadonlyArray<CapacityInput>,
  dayStartMin = DAY_START_MIN,
  dayEndMin = DAY_END_MIN,
): Capacity {
  const usedMin = tasks
    .filter((t) => t.status !== "done")
    .reduce((sum, t) => sum + (t.estMin ?? DEFAULT_EST_MIN), 0);
  const capMin = dayEndMin - dayStartMin;
  const pct = Math.min(100, capMin > 0 ? (usedMin / capMin) * 100 : 0);
  return { usedMin, capMin, pct, over: usedMin > capMin * 0.9 };
}
